/* Yuvakart — per-product overrides on the product page.

   Config comes from snippets/yk-offer-config.liquid.

   1. window.YK_OFFER      coupon code in the offer strip
   2. window.YK_PAGE_HIDE  rows to remove on brass and copper items
   3. window.YK_PAGE_SWAPS remaining certificate wording to reword

   Brass and copper carry no lab certificate and need no selenite charging,
   so on those 39 products the "Lab certificate" row in WHAT'S INCLUDED and
   the "Selenite-Charged" step in Ethically Sourced are removed outright
   rather than reworded — a substitute row still implies something extra is
   in the box.

   Finding the row: from the matching text node we climb up to six levels
   and take the first ancestor that has a sibling and whose own text is
   short. That identifies one item in a repeated list without needing to
   know the theme's class names, and the length guard stops it ever hiding
   a whole section by mistake.

   yk-coupon.js builds the tap-to-copy chip and flags the strip with
   data-ykcpn; that flag is cleared here so it rebuilds against the new
   code. This file must load BEFORE yk-coupon.js. */
(function () {
  'use strict';

  var CFG   = window.YK_OFFER;
  var HIDE  = window.YK_PAGE_HIDE;
  var SWAPS = window.YK_PAGE_SWAPS;
  if (!CFG && !HIDE && !SWAPS) return;

  function textNodes(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
    var out = [], n;
    while ((n = walker.nextNode())) {
      var p = n.parentNode;
      if (!p) continue;
      var tag = p.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') continue;
      if (n.nodeValue && n.nodeValue.trim()) out.push(n);
    }
    return out;
  }

  /* ---------- 1. offer strip ---------- */

  function swapOffer(root) {
    if (!root || !CFG || !CFG.find) return false;
    var nodes = textNodes(root), changed = false;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i], v = node.nodeValue;

      if (CFG.find.code && v.indexOf(CFG.find.code) > -1) {
        if (CFG.sub) {
          node.nodeValue = CFG.sub;
          if (node.parentElement) node.parentElement.classList.add('ykof-sub');
          changed = true;
        }
        continue;
      }
      if (CFG.find.title && v.indexOf(CFG.find.title) > -1) {
        if (CFG.title) { node.nodeValue = v.replace(CFG.find.title, CFG.title); changed = true; }
        continue;
      }
      if (CFG.find.save && v.trim() === CFG.find.save) {
        if (CFG.save) { node.nodeValue = v.replace(CFG.find.save, CFG.save); changed = true; }
        continue;
      }
    }

    if (changed) {
      root.removeAttribute('data-ykcpn');
      var old = root.querySelector('.ykcpn');
      if (old && old.parentNode) {
        old.parentNode.replaceChild(document.createTextNode(CFG.codeOnly || ''), old);
      }
    }
    return changed;
  }

  /* ---------- 2. remove rows ---------- */

  function rowFor(node) {
    var el = node.parentElement;
    for (var hop = 0; el && hop < 6; hop++) {
      var parent = el.parentElement;
      if (!parent) break;
      var siblings = parent.children ? parent.children.length : 1;
      var len = (el.textContent || '').trim().length;
      if (siblings > 1 && len > 0 && len < 220) return el;
      el = parent;
    }
    return null;
  }

  function hideRows(scope) {
    if (!HIDE || !HIDE.length) return;
    var nodes = textNodes(scope);

    for (var h = 0; h < HIDE.length; h++) {
      var phrase = HIDE[h];
      if (!phrase) continue;
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].nodeValue.indexOf(phrase) === -1) continue;
        var row = rowFor(nodes[i]);
        if (row && !row.getAttribute('data-ykhide')) {
          row.setAttribute('data-ykhide', '1');
          row.style.display = 'none';
        }
      }
    }
  }

  /* ---------- 3. reword what remains ---------- */

  function swapPage(scope) {
    if (!SWAPS || !SWAPS.length) return;
    var nodes = textNodes(scope);

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i], v = node.nodeValue, out = v;
      for (var s = 0; s < SWAPS.length; s++) {
        if (SWAPS[s].find && out.indexOf(SWAPS[s].find) > -1) {
          out = out.split(SWAPS[s].find).join(SWAPS[s].to);
        }
      }
      if (out !== v) node.nodeValue = out;
    }
  }

  function run() {
    var strips = document.querySelectorAll('.pp__offer');
    for (var i = 0; i < strips.length; i++) {
      if (strips[i].getAttribute('data-ykof')) continue;
      if (swapOffer(strips[i])) strips[i].setAttribute('data-ykof', '1');
    }
    var scope = document.querySelector('.pp') || document.body;
    hideRows(scope);
    swapPage(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  setTimeout(run, 200);
  setTimeout(run, 800);
  setTimeout(run, 2000);
  window.addEventListener('load', run);
  try {
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();